/*global google*/
import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarNew from '../NewAdminPanel/Common/AdminSideBar';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import { useNavigate, useLocation } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import blockedData from "../../config/blockedSchemes.json";

// Export constant loaded from JSON
export const BLOCKED_SCHEMES = blockedData.BLOCKED_SCHEMES;
//export const BLOCKED_SCHEMES = ["1", "8","2"];

const UserCreation = () => {
    // Read storage once

    //const [BLOCKED_SCHEMES, setBlockedSchemes] = useState([]);
    //useEffect(() => {
    //    // file path relative to public/
    //    fetch(`${process.env.PUBLIC_URL}/blockedSchemes.json`)
    //        .then((res) => res.json())
    //        .then((data) => {
    //            // expect { BLOCKED_SCHEMES: [...] }
    //            if (data && Array.isArray(data.BLOCKED_SCHEMES)) {
    //                setBlockedSchemes(data.BLOCKED_SCHEMES);
    //            }
    //        })
    //        .catch((err) => {
    //            console.error("Failed to load blockedSchemes.json", err);
    //            setBlockedSchemes([]); // fallback
    //        });
    //}, []);
    const schemeGlobal = sessionStorage.getItem("schemeCodeModel");

    // Use global variable
    //const isSchemeBlocked = blockedSchemes.includes(schemeGlobal);
    const isSchemeBlocked = BLOCKED_SCHEMES.includes(schemeGlobal);
    const navigate = useNavigate();
    const { state } = useLocation();
    const [stateValue, setStateValue] = useState("");
    const [districtValue, setDistrictValue] = useState("");
    const [subDistrictValue, setSubDistrictValue] = useState("");
    //const [blockValue, setBlockValue] = useState("");
    const [blockValue, setBlockValue] = useState([]);
    const [villageValue, setVillageValue] = useState("");
    const [blockValues, setBlockValues] = useState("");
    const [vCPValues, setVCPValues] = useState('');
    const [designationValue, setDesignationValue] = useState("");
    const [userRoleValue, setUserRoleValue] = useState("");
    const [userLevelValue, setUserLevelValue] = useState("");
    const [userNameValue, setUserNameValue] = useState("");
    const [mobileValue, setMobileValue] = useState("");
    const [emailValue, setEmailValue] = useState("");
    const [selectedOption, setSelectedOption] = useState("");
    const [statesData, setStatesData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [subDistrictData, setSubDistrictData] = useState([]);
    const [blockData, setBlockData] = useState([]);
    const [villageData, setVillageData] = useState([]);
    const [designationData, setDesignationData] = useState([]);
    const [vcpData, setVcpData] = useState([]);
    const [userRoleData, setUserRoleData] = useState("");
    const [selected, setSelected] = useState([]);
    let   [optionsState, setOptionsState] = useState([]);
    const [optionsDistrict, setOptionsDistrict] = useState([]);
    const [optionsSubDistrict, setOptionsSubDistrict] = useState([]);
    const [userCodeLocal, setUserCodeLocal] = useState("");
    const [gender, setGender] = useState('');
    const [selectedDist, setSelectedDist] = useState([]);
    const [selectedBlock, setSelectedBlock] = useState([]);
    const [isDisabledRadio, setIsDisabledRadio] = useState(true);
    const [isSubDistrictMultiSelect, setIsSubDistrictMultiSelect] = useState(true);

    const [selectedSubDistricts, setSelectedSubDistricts] = useState([]); // [{label, value}, ...]

    const [selectedDistricts, setSelectedDistricts] = useState([]); // [{label, value}, ...]

    const [selectedDistrictIds, setSelectedDistrictIds] = useState([]);

    const [clickUpdate, setClickUpdate] = useState(false);

    const [optionsSubDistrictNew, setOptionsSubDistrictNew] = useState([]);

    // add near other useState hooks
    const [multiSubDistrictVillages, setMultiSubDistrictVillages] = useState([]); // [{ label, value }]
    const [isUrban, setisUrban] = useState(false);
    const [agencyData, setAgencyData] = useState([]);
    const [agencyValue, setAgencyValue] = useState("");

    const handleSubDistrictMultiChange = (selectedOptions) => {
        const arr = Array.isArray(selectedOptions) ? selectedOptions : [];
        //console.log('arr : ', arr);


        setSelectedSubDistricts(arr);

        const codes = arr.map(o => o?.value).filter(Boolean);
        const names = arr.map(o => o?.label).filter(Boolean);
        // console.log('names sub-district: ', names);
        // console.log('codes sub-district: ', codes);
        sessionStorage.setItem("mulSubDistrictCode", codes.join(","));
        sessionStorage.setItem("mulSubDistrictName", names.join(","));

        // populate villages for ONLY the currently selected sub-districts
        if (codes.length === 0) {
            setMultiSubDistrictVillages([]);
            return;
        }

        const baseUrl = `${process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
            }/api/village`;

        const headers = { "Content-Type": "application/json" };

        // use current district selection already present in this component
        const currentDistrictCode = districtValue;

        //console.log('districtValue: ', districtValue);

        Promise.all(
            codes.map((subdistrictcode, index) => {
                const body = JSON.stringify({
                    subdistrictcode,
                    districtcode: currentDistrictCode
                });
                //console.log("index:", arr[index].label);
                // console.log("Label at index:", arr[index].label);
                //console.log('subdistrictcode: ', subdistrictcode);
                // console.log('body: ', body);

                return fetch(baseUrl, {
                    method: "POST",
                    headers,
                    body,
                    redirect: "follow"
                })
                    .then((response) => response.text())
                    .then((text) => {
                        const parsed = JSON.parse(text);
                        const data = Array.isArray(parsed?.dataContent) ? parsed.dataContent : [];
                        return data.map((item) => ({
                            label: `${item.villageName} (${item.villageCode}) - (Sub-District: ${arr[index].label})`,
                            value: item.villageCode
                        }));
                    })
                    .catch(() => []);
            })
        )
            .then((villagesArrays) => {
                // flatten and de-duplicate by village code
                const merged = [];
                const seen = new Set();
                villagesArrays.flat().forEach((v) => {
                    if (!seen.has(v.value)) {
                        seen.add(v.value);
                        merged.push(v);
                    }
                });
                setMultiSubDistrictVillages(merged);
            })
            .catch(() => {
                setMultiSubDistrictVillages([]);
            });

        // console.log('setRetrievedArraySubDistrict: ', retrievedArraySubDistrict);

        //const codeValues = retrievedArraySubDistrict.map(item => item.code);
        //console.log("codeValues: ", codeValues);
    };

    const stateTrueBindVillagesForBlock = async () => {
        const baseUrl = `${process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
            }/api/village`;
        const headers = { "Content-Type": "application/json" };

        // block codes come from state (comma-separated); normalize to array
        const rawBlockCodes = state?.cropSurveyCode?.mulBlockCode || "";
        const blockCodes = rawBlockCodes
            .split(",")
            .map(code => code.trim())
            .filter(code => code.length > 0);

        if (blockCodes.length === 0) {
            setMultiSubDistrictVillages([]);
            return;
        }

        let currentDistrictCode = sessionStorage.getItem("districtCodeModel");
        if (!currentDistrictCode || currentDistrictCode === "null" || currentDistrictCode.trim() === "") {
            currentDistrictCode = state?.cropSurveyCode?.districtCode?.toString() || "";
        }

        const allVillages = await Promise.all(
            blockCodes.map(async (blockcode, index) => {
                const body = JSON.stringify({
                    blockcode,
                    districtcode: currentDistrictCode
                });

                try {
                    const response = await fetch(baseUrl, {
                        method: "POST",
                        headers,
                        body,
                        redirect: "follow"
                    });

                    const text = await response.text();
                    const parsedResponse = JSON.parse(text);
                    const data = Array.isArray(parsedResponse?.dataContent)
                        ? parsedResponse.dataContent
                        : [];

                    const blockNames = (state?.cropSurveyCode?.mulBlockName || "")
                        .split(",")
                        .map(name => name.trim());

                    const blockName = blockNames[index] || `Block ${blockcode}`;

                    return data.map((item) => ({
                        label: `${item.villageName} (${item.villageCode}) - (Block: ${blockName})`,
                        value: item.villageCode,
                    }));
                } catch (error) {
                    console.error("Error fetching data for block:", blockcode, error);
                    return [];
                }
            })
        );

        setMultiSubDistrictVillages(allVillages.flat());
    };

    const stateTrueBindVillages = async () => {
        // console.log("stateTrueBindVillages called");

        const baseUrl = `${process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
            }/api/village`;

        const headers = { "Content-Type": "application/json" };

        // use current district selection already present in this component
        let currentDistrictCode = sessionStorage.getItem("districtCodeModel");
        //console.log("districtValue from sessionStorage:", currentDistrictCode);

        const raw = sessionStorage.getItem("districtArray");
        const parsed = raw ? JSON.parse(raw) : [];

        // Sort by name (case-insensitive)
        const sorted = Array.isArray(parsed)
            ? [...parsed].sort((a, b) =>
                String(a.name || "").localeCompare(String(b.name || ""), undefined, {
                    sensitivity: "base",
                })
            )
            : [];

        //console.log("sorted:", sorted);

        const stored = sessionStorage.getItem("SubDistrictUserBasedData");
        const parsedValues = stored ? JSON.parse(stored) : [];

        // extract only the `value` fields
        const codes = parsedValues.map(item => item.value);
        const labels = parsedValues.map(item => item.label);
        //console.log('currentDistrictCode if state:', currentDistrictCode);

        //console.log('currentDistrictCode value type:', typeof currentDistrictCode);

        if (state) {

            const districtFromState = state.cropSurveyCode?.districtCode?.toString() ?? "";
            //console.log('districtFromState:', districtFromState);
            // If district from session is null / "" / undefined
            if (currentDistrictCode === "null" || currentDistrictCode.trim() === "") {
                //console.log("if in state currentDistrictCode");

                // update local variable
                currentDistrictCode = districtFromState;

                // **IMPORTANT** update sessionStorage also
                // sessionStorage.setItem("districtCodeModel", districtFromState);
            }

            //console.log("state.cropSurveyCode.districtCode:", districtFromState);

            //// if (!currentDistrictCode)
            // if (!currentDistrictCode || currentDistrictCode.trim() === ""){
            //    console.log('if in state currentDistrictCode');
            //     currentDistrictCode = state.cropSurveyCode.districtCode;
            // }
            // console.log('if in state');
            // console.log('state.cropSurveyCode.districtCode: ', state.cropSurveyCode.districtCode);
        } else {
            console.log('else in state');
        }

        //setDistrictValue

        //const codes = sorted.map((item) => item.code);

        // console.log("codes:", codes);
        // console.log('currentDistrictCode: ', currentDistrictCode);
        const allVillages = await Promise.all(
            codes.map(async (subdistrictcode, index) => {
                const body = JSON.stringify({
                    subdistrictcode,
                    districtcode: currentDistrictCode,
                });
                //console.log('parsedValues: ', parsedValues);

                // console.log("index:", index);
                // console.log("body:", body);

                try {
                    const response = await fetch(baseUrl, {
                        method: "POST",
                        headers,
                        body,
                        redirect: "follow",
                    });

                    const text = await response.text();
                    // console.log("text:", text);

                    const parsedResponse = JSON.parse(text);
                    // console.log("parsed:", parsedResponse);

                    const data = Array.isArray(parsedResponse?.dataContent)
                        ? parsedResponse.dataContent
                        : [];
                    //console.log("data:", data);

                    // Use sorted (since retrievedArraySubDistrict isn't defined)
                    const subDistrictName = parsedValues[index]?.label || "Unknown";

                    return data.map((item) => ({
                        label: `${item.villageName} (${item.villageCode}) - (Sub-District: ${subDistrictName})`,
                        value: item.villageCode,
                    }));
                } catch (error) {
                    console.error(
                        "Error fetching data for subdistrict:",
                        subdistrictcode,
                        error
                    );
                    return [];
                }
            })
        );

        // flatten nested arrays into one
        const villages = allVillages.flat();

        console.log("villages:", villages);
        setMultiSubDistrictVillages(villages);
        // optionally return if needed
        // return villages;
    };


    const showGender = () => {
        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        return (
            schemeCode !== "5" ||
            (schemeCode === "5" && userLevelValue !== 4 && userLevelValue !== 6)
        );
    };

    useEffect(() => {

        fetchDesignation();


    }, []);


    const [retrievedArraySubDistrict, setRetrievedArraySubDistrict] = useState(
        []
    );

    useEffect(() => {
        try {

            const raw = sessionStorage.getItem("districtArray");
            const parsed = raw ? JSON.parse(raw) : [];
            const sorted = Array.isArray(parsed)
                ? [...parsed].sort((a, b) =>
                    String(a.name || "").localeCompare(
                        String(b.name || ""),
                        undefined,
                        { sensitivity: "base" }
                    )
                )
                : [];
            setRetrievedArraySubDistrict(sorted);
        } catch (err) {
            console.warn("Invalid districtArray in sessionStorage:", err);
            setRetrievedArraySubDistrict([]);
        }
    }, []);

    useEffect(() => {
        if (retrievedArraySubDistrict?.length) {
            const sortedOptions = [...retrievedArraySubDistrict]
                .sort((a, b) =>
                    String(a.name || "").localeCompare(String(b.name || ""), undefined, {
                        sensitivity: "base",
                    })
                )
                .map((district) => ({
                    label: `${district.name} (${district.code})`,
                    value: String(district.code),
                }));

            setOptionsSubDistrictNew(sortedOptions);
        }
    }, [retrievedArraySubDistrict]);


    useEffect(() => {
        if (Array.isArray(userRoleData) && userRoleData.length > 0 && !userRoleValue) {
            setUserRoleValue(userRoleData[0].userRoleCode.toString());
        }
    }, [userRoleData]);

    useEffect(() => {

        const role = sessionStorage.getItem("userTypeCodeModel");
        const scheme = sessionStorage.getItem("schemeCodeModel");
        //console.log('role: ', role);
        const x = document.getElementById("userType");

        if (!x) return;

        // Helper to add options
        const addOption = (text, value) => {
            const option = document.createElement("option");
            option.text = text;
            option.value = value;
            x.add(option);
        };


        //if (role === "1") {
        //    addOption("State", "2");
        //    addOption("District", "3");

        //    if (scheme === "5") {
        //        addOption("VCP", "4");
        //    } else {

        //        addOption("SubDistrict", "4");
        //    }
        //    addOption("Surveyor", "5");
        //    //addOption("Supervisor", "7");


        //} 

        if (role === "1") {
            addOption("State", "2");
            addOption("District", "3");

            if (scheme === "5") {
                addOption("VCP", "4");
            } else {
                if (state) {
                    addOption("SubDistrict", "4");
                } else {
                    // if (scheme !== "8") {
                    //if (scheme !== "8" && scheme !== "1") {
                    //    addOption("SubDistrict", "4");
                    //}
                    if (!BLOCKED_SCHEMES.includes(schemeGlobal)) {
                        addOption("SubDistrict", "4");
                    }


                }
            }
            if (state) {
                addOption("Surveyor", "5");
            } else {
                // if (scheme !== "8") {
                //if (scheme !== "8" && scheme !== "1") {
                //    addOption("Surveyor", "5");
                //}
                if (!BLOCKED_SCHEMES.includes(schemeGlobal)) {
                    addOption("Surveyor", "5");
                }

            }
            if(scheme === "44"){
            addOption("Central Agency", "6");
            addOption("State Agency", "7");
            }

        } else if (role === "2") {
            getStates();
            handleState(Number(sessionStorage.getItem("stateNameModel")));
            setStateValue(sessionStorage.getItem("stateNameModel"));
            const stateEl = document.getElementById("State");
            if (stateEl) stateEl.disabled = true;

            addOption("District", "3");
            if (scheme === "5") {
                addOption("VCP", "4");
            } else {
                if (state) {
                    addOption("SubDistrict", "4");
                } else {
                    // if (scheme !== "8") {
                    //if (scheme !== "8" && scheme !== "1") { 
                    if (!BLOCKED_SCHEMES.includes(schemeGlobal)) {
                        addOption("SubDistrict", "4");
                    }
                }
            }
            if (state) {
                addOption("Surveyor", "5");
            } else {
                // if (scheme !== "8") {
                //if (scheme !== "8" && scheme !== "1") { 
                if (!BLOCKED_SCHEMES.includes(schemeGlobal)) {
                    addOption("Surveyor", "5");
                }
            }

        } else if (role === "3") {
            // console.log('role=3');
            getStates();
            handleState(Number(sessionStorage.getItem("stateNameModel")));
            setStateValue(sessionStorage.getItem("stateNameModel"));
            setDistrictValue(sessionStorage.getItem("districtCodeModel"));

            handleDistrict(sessionStorage.getItem("districtCodeModel"));

            const stateEl = document.getElementById("State");
            const districtEl = document.getElementById("District");
            if (stateEl) stateEl.disabled = true;
            if (districtEl) districtEl.disabled = true;

            if (scheme === "5") {
                addOption("VCP", "4");
            } else {
                addOption("SubDistrict", "4");
            }
            addOption("Surveyor", "5");

        } else if (role === "4") {
            //console.log('role=4');
            getStates();
            handleState(Number(sessionStorage.getItem("stateNameModel")));
            setStateValue(sessionStorage.getItem("stateNameModel"));
            setDistrictValue(sessionStorage.getItem("districtNameModel"));
            setSubDistrictValue(sessionStorage.getItem("subDistrictCodeModel"));

            handleDistrict(sessionStorage.getItem("districtCodeModel"));

            handleVillage(
                sessionStorage.getItem("subDistrictCodeModel"),
                sessionStorage.getItem("districtCodeModel")
            );

            const stateEl = document.getElementById("State");
            const districtEl = document.getElementById("District");
            const subDistEl = document.getElementById("subDistrict");

            if (stateEl) stateEl.disabled = true;
            if (districtEl) districtEl.disabled = true;
            if (subDistEl) subDistEl.disabled = true;

            addOption("Surveyor", "5");
        }


        if (scheme === "5" && role !== "4") {
            addOption("Sakhi", "6");

        }
    }, []);


    const fetchSubDistrictUserBasedData = async (userid) => {
        const schemeCodeModel = sessionStorage.getItem("schemeCodeModel");
        const result = await axios.post(
            `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Management/CommUsers/getSubDistrictBasedOnUser`,
            { schemeCode: schemeCodeModel, userCode: userid }
        );
        const subArr = Array.isArray(result?.data?.dataContent) ? result.data.dataContent : [];
        const selected = subArr
            .map(item => ({
                label: `${item.subDistrictName} (${item.subDistrictCode})`,
                value: String(item.subDistrictCode),
            }))
            .filter(o => o.label && o.value);
        setSelectedSubDistricts(selected); // ONE argument; correct shape for MultiSelect

        sessionStorage.setItem("SubDistrictUserBasedData", JSON.stringify(selected));
        // console.log("fetchSubDistrictUserBasedData11", selected);
    };

    const fetchBlockUserBasedData = async (userid) => {
        //console.log('fetchBlockUserBasedData called:', userid);
        const schemeCodeModel = sessionStorage.getItem("schemeCodeModel");
        const result = await axios.post(
            `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Management/CommUsers/getBlockBasedOnUser`,
            { schemeCode: schemeCodeModel, userCode: userid }
        );
        const subArr = Array.isArray(result?.data?.dataContent) ? result.data.dataContent : [];
        //console.log('subArr block: ', subArr);
        const selected = subArr
            .map(item => ({
                label: `${item.blockName} (${item.blockCode})`,
                //value: String(item.blockCode),
                value: item.blockCode
            }))
            .filter(o => o.label && o.value);
        setSelectedBlock(selected);
        //setBlockValue(selected); // ONE argument; correct shape for MultiSelect

        sessionStorage.setItem("blockUserBasedData", JSON.stringify(selected));
        //console.log("fetchBlockUserBasedData", selected);
    };




    const fetchDistrictUserBasedData = async (userid) => {
        const schemeCodeModel = sessionStorage.getItem("schemeCodeModel");
        const result = await axios.post(
            `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Management/CommUsers/getDistrictBasedOnUser`,
            { schemeCode: schemeCodeModel, userCode: userid }
        );

        const localFormDataDist = Array.isArray(result?.data?.dataContent) ? result.data.dataContent : [];
        // console.log("localFormDataDist", localFormDataDist);

        // Keep IDs (strings) for selection state
        const idList = localFormDataDist.map(item => String(item.districtCode));
        setSelectedDistrictIds(idList);

        // Optional: also keep a pretty selection list if needed elsewhere
        const prettyList = localFormDataDist.map(item => ({
            label: `${item.districtName} (${item.districtCode})`,
            value: String(item.districtCode),
        }));
        setSelectedDistricts(prettyList);
    };


    const selectedDistrictOptions = useMemo(() => {
        const idSet = new Set(selectedDistrictIds.map(String));
        return optionsDistrict.filter(opt => idSet.has(String(opt.value)));
    }, [optionsDistrict, selectedDistrictIds]);

    useEffect(() => {
        const initializeData = async () => {
            if (state) {
                console.log('state: ', state);
                //console.log('state.cropSurveyCode.subDistrictCode: ', state.cropSurveyCode.subDistrictCode);

                setUserLevelValue(
                    state.cropSurveyCode.userTypeCode != null && state.cropSurveyCode.userTypeCode !== ""
                        ? String(state.cropSurveyCode.userTypeCode)
                        : ""
                );
                getStates();
                handleState(state.cropSurveyCode.stateCode);

                // Wait for SubDistrict data to load before proceeding
                await fetchSubDistrictUserBasedData(state.cropSurveyCode.userCode);
                fetchBlockUserBasedData(state.cropSurveyCode.userCode);
                fetchDistrictUserBasedData(state.cropSurveyCode.userCode);

                handleDistrict(state.cropSurveyCode.districtCode);

                //handleVillage(state.cropSurveyCode.subDistrictCode, state.cropSurveyCode.districtCode);

                setVillageValue(state.cropSurveyCode.villageCode);
                setSubDistrictValue(state.cropSurveyCode.subDistrictCode);
                setUserNameValue(state.cropSurveyCode.userName);
                setMobileValue(state.cropSurveyCode.mobile);
                setEmailValue(state.cropSurveyCode.emailId);
                setDesignationValue(state.cropSurveyCode.designationCode);
                fetchUserRole(state.cropSurveyCode.userTypeCode, "state");
                setUserRoleValue(state.cropSurveyCode.userRoleCode);
                setUserCodeLocal(state.cropSurveyCode.userCode);
                setGender(state.cropSurveyCode.gender);
                setDistrictValue(state.cropSurveyCode.districtCode);

                // console.log('Calling stateTrueBindVillages AFTER subdistrict data');
                stateTrueBindVillages();
                setIsSubDistrictMultiSelect(false);

                // build village list
                let villageCode = String(state.cropSurveyCode.villageCode).includes(",")
                    ? state.cropSurveyCode.villageCode.split(",")
                    : [state.cropSurveyCode.villageCode];

                let villageName = String(state.cropSurveyCode.villageName).includes(",")
                    ? state.cropSurveyCode.villageName.split(",")
                    : [state.cropSurveyCode.villageName];

                let myArray = villageCode.map((code, i) => ({
                    label: villageName[i],
                    value: code,
                }));

                let villageCodeNumber = villageCode.map(Number);
                setSelected(villageCodeNumber);

                // console.log('state.cropSurveyCode.mulBlockName: ', state.cropSurveyCode.mulBlockName);
                const rawMulBlock = state?.cropSurveyCode?.mulBlockName;
                const hasUrban = typeof rawMulBlock === "string" && rawMulBlock.trim().length > 0;
                setisUrban(hasUrban);
                //console.log('hasUrban: ', hasUrban);
                // Disable radios when in edit mode (state exists)
                setIsDisabledRadio(true);
                setSelectedOption(hasUrban ? "option1" : "option2");
                if (hasUrban) {
                    stateTrueBindVillagesForBlock();

                } else {
                    handleVillage(state.cropSurveyCode.subDistrictCode, state.cropSurveyCode.districtCode);
                }
                //console.log("fronm edit mode");
            }
            else {
                //console.log("fronm add mode");
                // Enable /Disable radios when creating new user
                //console.log('radios when creating new user');
                if (sessionStorage.getItem("schemeCodeModel") === "2" && !sessionStorage.getItem("subDistrictCodeModel")?.trim()) {
                    //console.log('radios when creating new user if');
                    setSelectedOption("option1");
                    setIsDisabledRadio(true);
                } else {
                    // console.log('radios when creating new user else');
                    setSelectedOption("option2");
                    setIsDisabledRadio(true);
                }
            }
        };

        initializeData();
    }, []);



    const handleRadioChange = (e) => {
        setSelectedOption(e.target.value);
        setBlockValues([]);
        //setSelectedSubDistricts([]);
        //setSubDistrictData([]);
        // console.log('selectedSubDistricts inside handleRadioChange', selectedSubDistricts);
    };

    const fetchDesignation = async () => {
        const result = await axios(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/Management/commDesignation`
        );
        setDesignationData(result.data.dataContent);
    };

    const fetchVCPData = async (value) => {
        let state;

        if (sessionStorage.getItem("stateNameModel") !== "null") {
            state = sessionStorage.getItem("stateNameModel");
        } else {
            state = stateValue;
        }
        const result = await axios.post(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/NMEOSUsers/getNMEOSVCPUserList`, {
            "schemeCode": 5,
            "orgTypeCode": 4,
            "int_State_Code": state,
            "int_District_Code": value
        }
        );
        // console.log("userLevelValue", userLevelValue)



        setVcpData(result.data.dataContent);
        // console.log("vcpData-------------", vcpData)


    };


    const fetchUserRole = async (value, key) => {
        // console.log('fetchUserRole function call');
        // console.log('fetchUserRole function call value:', value);
        // console.log('fetchUserRole function call key:', key);
        // console.log('fetchUserRole function call schemeCodeModel:', sessionStorage.getItem("schemeCodeModel"));
        const result = await axios.post(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/PDMC/pdmcUserRole/GetPDMCRolebySchemeCode`, {
            "schemeCode": sessionStorage.getItem("schemeCodeModel"),
            "userTypeCode": value
        });
        setUserRoleData(result.data.dataContent);
    };

    const fetchAgencyData = async (agencyTypeId) => {
        try {
            const baseUrl = process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE;
            const result = await axios.post(
                `${baseUrl}/api/Helper/GetAgencyTypeName`,
                { agencyTypeId }
            );
            console.log("fetchAgencyData response:", result.data);
            setAgencyData(Array.isArray(result.data.dataContent) ? result.data.dataContent : []);
        } catch (err) {
            console.error("fetchAgencyData error:", err);
            setAgencyData([]);
        }
    };

    function getStates() {
        const fetchStates = async () => {
            const result = await axios(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/states`
            );
            setStatesData(result.data.dataContent);
        };
        fetchStates();
    }

    function handleState(value) {
        if (value === "NA") { return }
        setStateValue(value);
        setDistrictData([]);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            stateCode: Number(value),
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/district`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
                const parsedResult = JSON.parse(result);
                setDistrictData(parsedResult.dataContent);

                let localFormDataDist = parsedResult.dataContent;
                //console.log("localFormDataDist", localFormDataDist);
                const myArray = localFormDataDist.map((item) => ({
                    label: `${item.districtName} (${item.districtCode})`,
                    value: item.districtCode,
                }));
                // console.log("myArray", myArray)
                setOptionsDistrict(myArray)
            })
            .catch((error) => console.log("error", error));

    }

    function handleDistricts(value) {
        // console.log('handleDistricts');

        if (value === "NA") { return }

        setDistrictValue(value);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            DistrictCode: Number(value),
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/subdistrict`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => setSubDistrictData(JSON.parse(result).dataContent))
            .catch((error) => console.log("error", error));
    }

    function handleDistrict(value) {

        //console.log('value handleDistrict:', value);

        if (value === "NA") return;

        setDistrictValue(value);

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const rawSubDistrict = JSON.stringify({
            DistrictCode: Number(value),
        });
       // console.log('rawSubDistrict: ', rawSubDistrict);
        const subDistrictRequestOptions = {
            method: "POST",
            headers: myHeaders,
            body: rawSubDistrict,
            redirect: "follow",
        };

        // First API: Sub-district fetch
        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/subdistrict`,
            subDistrictRequestOptions
        )
            .then((response) => response.text())
            .then((result) => {
                const parsed = JSON.parse(result);
                setSubDistrictData(parsed.dataContent);

                let localFormDataSubDist = parsed.dataContent;
                const myArray = localFormDataSubDist.map((item) => ({
                    label: `${item.subDistrictName} (${item.subDistrictCode})`,
                    value: String(item.subDistrictCode),
                })); console.log('myArray subDistrict: ', myArray)
                setOptionsSubDistrict(myArray)

                if (sessionStorage.getItem("schemeCodeModel") === "5") {
                    fetchVCPData(value)

                }
            })
            .catch((error) => console.log("error in subdistrict API", error));

        // Second API: Block fetch
        const rawBlock = JSON.stringify({
            blockCode: 0,
            blockName: "",
            subDistrictCode: 0,
            districtCode: Number(value),
            visibility: 1
        });

        //console.log('rawBlock: ', rawBlock);
        const blockRequestOptions = {
            method: "POST",
            headers: myHeaders,
            body: rawBlock,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/block`,
            blockRequestOptions
        )
            .then((response) => response.text())
            .then((result) => {
                const parsed = JSON.parse(result);
                setBlockValue(parsed.dataContent);  // Push result into state
                console.log('parsed.dataContent: ', parsed.dataContent);
            })
            .catch((error) => console.log("error in block API", error));
    }

    //function handleBlockMulSelect(value) {
    //    console.log('districtValue: ', districtValue);
    //    console.log('Value: ', value);
    //   // console.log('blockValues: ', blockValues);
    //   // alert(districtValue);
    //    sessionStorage.setItem("mulBlockCode", value);
    //    sessionStorage.setItem("mulBlockName1", JSON.stringify(blockValues));
    //    sessionStorage.setItem("mulBlockName", blockValues.map(i => i.label).join(","));

    //    // populate villages for ONLY the currently selected sub-districts
    //    if (value.length === 0) {
    //        setMultiSubDistrictVillages([]);
    //        return;
    //    }

    //}

    function handleBlockMulSelect(selected) {
        const values = selected.map(i => i.value);
        const labels = selected.map(i => i.label).join(",");
        const arrBlockName = selected.map(i => i.label);
        console.log('labels: ', labels);
        console.log('arrBlockName: ', arrBlockName);

        console.log("Values:", values);

        sessionStorage.setItem("mulBlockCode", values);
        // sessionStorage.setItem("mulBlockName1", JSON.stringify(selected));
        sessionStorage.setItem("mulBlockName", labels);

        if (values.length === 0) {
            setMultiSubDistrictVillages([]);
            return;
        }
        const baseUrl = `${process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
            }/api/village`;

        const headers = { "Content-Type": "application/json" };

        const currentDistrictCode = districtValue;
        Promise.all(
            values.map((blockcode, index) => {
                const body = JSON.stringify({
                    blockcode: String(blockcode),
                    districtcode: currentDistrictCode
                });
                console.log('body: ', body);

                return fetch(baseUrl, {
                    method: "POST",
                    headers,
                    body,
                    redirect: "follow"
                })
                    .then((response) => response.text())
                    .then((text) => {
                        const parsed = JSON.parse(text);
                        const data = Array.isArray(parsed?.dataContent) ? parsed.dataContent : [];
                        return data.map((item) => ({
                            label: `${item.villageName} (${item.villageCode}) - (Block: ${arrBlockName[index]})`,
                            value: item.villageCode
                        }));
                    })
                    .catch(() => []);
            })
        )
            .then((villagesArrays) => {
                // flatten and de-duplicate by village code
                const merged = [];
                const seen = new Set();
                villagesArrays.flat().forEach((v) => {
                    if (!seen.has(v.value)) {
                        seen.add(v.value);
                        merged.push(v);
                    }
                });
                setMultiSubDistrictVillages(merged);
            })
            .catch(() => {
                setMultiSubDistrictVillages([]);
            });

    }

    function handleBlock(value) {
        //console.log('districtValue: ', districtValue);
        //console.log('Value: ', value);
        //console.log('blockValues: ', blockValues);
        alert(districtValue);
        setBlockValues(value);

        var myHeaders = new Headers();
        var raw = JSON.stringify({
            blockCode: value,
            districtcode: districtValue,
        });
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/village`,
            requestOptions
        )
            .then((response) => response.text())
            // .then((result) => setVillageData(JSON.parse(result).dataContent) {
            .then((result) => {
                let localFormData = JSON.parse(result).dataContent;
                //console.log("localFormData", localFormData);
                const myArray = localFormData.map((item) => ({
                    label: `${item.villageName} (${item.villageCode})`,
                    value: item.villageCode,
                }));
                // console.log("myArray", myArray)
                setOptionsState(myArray)
            })
            .catch((error) => console.log("error", error));

    }
    function handleVillage(subDvalue, DValue) {
        // console.log('handleVillage called')
        setSubDistrictValue(subDvalue)
        // if(value === "NA") { return}
        if (subDvalue != null && DValue != null) {
            var raw = JSON.stringify({
                subdistrictcode: subDvalue,
                districtcode: DValue,
            });
        } else {
            var raw = JSON.stringify({
                subdistrictcode: subDvalue,
                districtcode: districtValue,
            });
        }

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/village`,
            requestOptions
        )
            .then((response) => response.text())
            // .then((result) => setVillageData(JSON.parse(result).dataContent) {
            .then((result) => {
                let localFormData = JSON.parse(result).dataContent;
                const myArray = localFormData.map((item) => ({
                    label: `${item.villageName} (${item.villageCode})`,
                    value: item.villageCode,
                }));
                setOptionsState(myArray)
            })
            .catch((error) => console.log("error", error));

    }


    function handleResetForm() {

        setStateValue("");
        setDistrictValue("");
        setUserNameValue("");
        setSubDistrictValue("");
        setVillageValue("");
        setDesignationValue("");
        setUserRoleValue("");
        setUserLevelValue("");
        setMobileValue("");
        setSelected([])
        setEmailValue("");
        setGender("")

    }

    function ValidateAddUser() {

        const scheme = sessionStorage.getItem("schemeCodeModel");
        let valid = false;

        if (userLevelValue === "Choose..." || userLevelValue === "") {
            alert("Select Any User Level Value")

            valid = false;
            return;
        } else {
            valid = true;

        }

        if (userLevelValue !== "7" && (stateValue === "Choose..." || stateValue === "")) {
            alert("Select Any State Value")

            valid = false;
            return;
        } else {
            valid = true;

        }

        // For MultiSelect component (when schemeCodeModel === "8")
        //const scheme = sessionStorage.getItem("schemeCodeModel");
        //if (sessionStorage.getItem("schemeCodeModel") === "8" || sessionStorage.getItem("schemeCodeModel") === "1") {
        if (userLevelValue !== "7" && BLOCKED_SCHEMES.includes(schemeGlobal)) {
            // Normalize the selected IDs array
            const districtIds = Array.isArray(selectedDistrictIds)
                ? selectedDistrictIds.map(String).filter(Boolean)
                : [];
            if (userLevelValue === 3) {
                if (userLevelValue > 2 && (!districtIds || districtIds.length === 0)) {
                    valid = false;
                    alert("Select Any District");
                    return;
                } else {
                    valid = true;
                }
            } else if (userLevelValue === 4) { //This complete block was commented
                if (String(districtValue) === "" || String(districtValue) === "Choose..." || String(districtValue) === "NA") {
                    valid = false;
                    //console.log('333333333');
                    alert("Select Any District");
                    return;
                } else {
                    valid = true;
                }

            }

        }
        // For regular select component (other scheme codes)
        else if (userLevelValue !== "7") {
            //console.log('else gular select component (other scheme codes)');
            if (userLevelValue > 2 && (districtValue === "" || districtValue === "Choose..." || districtValue === "NA")) {
                valid = false;
                alert("Select Any District");
                return;
            } else {
                valid = true;
            }
        }

        if (userLevelValue !== "7" && scheme !== "5") {
            //if (sessionStorage.getItem("schemeCodeModel") === "8" || sessionStorage.getItem("schemeCodeModel") === "1") {
            if (BLOCKED_SCHEMES.includes(schemeGlobal)) {
                //console.log('selected: ', selected);
                console.log('selectedSubDistricts: ', selectedSubDistricts);
                console.log('isUrban: ', isUrban);
                console.log('isUrbselectedOptionan: ', selectedOption);

                console.log('selectedBlock1111: ', selectedBlock);

                if (userLevelValue === 4) {
                    if (selectedOption === "option1") {

                        if (!Array.isArray(selectedBlock) || selectedBlock.length === 0) {

                            alert("Select at least one Block");
                            return;
                        } else {
                            //console.log('pppppppppp');
                            // Optional: persist selections
                            const codes = selectedBlock.map(o => o?.value).filter(Boolean).join(",");
                            const names = selectedBlock.map(o => o?.label).filter(Boolean).join(",");
                            sessionStorage.setItem("mulBlockCode", codes);
                            sessionStorage.setItem("mulBlockName", names);
                            valid = true;

                        }
                    } else {
                        if (!Array.isArray(selectedSubDistricts) || selectedSubDistricts.length === 0) {

                            alert("Select at least one Sub-District");
                            return;
                        } else {
                            //console.log('pppppppppp');
                            // Optional: persist selections
                            const codes = selectedSubDistricts.map(o => o?.value).filter(Boolean).join(",");
                            const names = selectedSubDistricts.map(o => o?.label).filter(Boolean).join(",");
                            sessionStorage.setItem("mulSubDistrictCode", codes);
                            sessionStorage.setItem("mulSubDistrictName", names);
                            valid = true;

                        }
                    }

                }

            } else {


                if (selectedOption !== "option1" && userLevelValue > 3 && (subDistrictValue === "" || subDistrictValue === "Choose..." || subDistrictValue === "NA")) {
                    valid = false;

                    alert("Select Any SubDistrict")
                    return;

                } else {
                    valid = true;
                }
            }

        }

        if (userLevelValue !== "7" && scheme !== "5") {

            if (userLevelValue > 4 && (selected.length === 0)) {
                valid = false;

                alert("Select Any Village")
                return;

            } else {

                valid = true;
            }
        }


        if (userRoleValue === "Choose..." || userRoleValue === "") {

            alert("Select Any User Role Value")

            valid = false;
            return;
        } else {

            valid = true;

        }

        if (userNameValue === "") {

            valid = false;
            alert("Enter Correct User Name")
            return;
        } else {

            valid = true
        }

        if (userLevelValue !== "4" && userLevelValue !== "6") {

            if (gender === "") {

                valid = false;
                alert("Select Any Gender")
                return;
            } else {
                valid = true
            }
        }

        if (document.getElementById("mobilenumber").style.borderColor === "red" || document.getElementById("mobilenumber").value.length === 0) {

            valid = false;
            alert("Enter Correct Mobile Number")
            return;

        } else {

            valid = true

        }

        if (userNameValue === "") {
            valid = false;
            alert("Enter Correct User Name");
            return;
        } else if (!/^[a-zA-Z\s]+$/.test(userNameValue)) {
            valid = false;
            alert("User Name should contain only alphabets");
            return;
        } else {
            valid = true;
        }

        if (mobileValue === "") {

            alert("Enter Valid Mobile Number")

            valid = false;
            return;
        } else {

            valid = true;

        }

        if (designationValue === "Choose..." || designationValue === "") {

            alert("Select Any Designation Value")

            valid = false;
            return;
        } else {

            valid = true;

        }

        if (document.getElementById("emailid").style.borderColor === "red" || document.getElementById("emailid").value.length === 0) {
            valid = false;

            alert("Enter Correct Email Address")
            return;
        } else {

            valid = true
        }





        //  if(mobileVerify === false) {
        //    alert("Verify mobile number")
        //    valid = false;
        //   return;
        //  } else {
        //    valid = true;

        //  }
        // console.log('valid: ', valid);


        if (valid === true) {
            state ? UpdateUser() : AddNewUser()
        }



    }


    function AddNewUser() {

        // console.log('State AddNewUser: ', state);
        let localVillageValue = "";

        selected.map((item) => {
            localVillageValue = localVillageValue + item + ",";
        });

        localVillageValue = localVillageValue.slice(0, -1); // Remove trailing comma

        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        //console.log('subDistrictValue: ', subDistrictValue);

        let payload = {
            createdByUC: sessionStorage.getItem("userCodeModel"),
            userRoleCode: userRoleValue,
            userName: userNameValue,
            userId: mobileValue,
            mobile: mobileValue,
            emailId: emailValue,
            departmentCode: "1",
            designationCode: designationValue,
            stateCode: stateValue,

            //subDistrictCode: !subDistrictValue ? "0" : String(subDistrictValue),
            subDistrictCode: subDistrictValue ? String(subDistrictValue) : "0", //changed at 14 Nov 2025
            villageCode: Number(userLevelValue) > 4 ? String(localVillageValue) : "",
            userTypeCode: userLevelValue,
            schemeCode: schemeCode,
            isMobileVerified: "N",
            isEmailVerified: "N",
            orgTypeCode: "1",
        };

        // if (schemeCode === "8" || schemeCode === "1") {
        if (BLOCKED_SCHEMES.includes(schemeGlobal)) {
            const ids = Array.isArray(selectedDistrictIds)
                ? selectedDistrictIds.map(id => Number(id)).filter(Number.isFinite)
                : [];

            if (ids.length > 0) {
                payload.mulDistrictCode = ids.join(",");
                payload.districtCode = "";
            } else {
                payload.mulDistrictCode = "";
                const districtCode = sessionStorage.getItem("districtCodeModel");
                payload.districtCode = districtCode && districtCode !== "null" ? districtCode : "";
            }
            const commaValues = Array.isArray(blockValues) && blockValues.length > 0
                ? blockValues.map(i => i.value).join(",")
                : "";
            // console.log('blockValues val: ', blockValues.map(i => i.value).join(","));
            payload.mulBlockCode = commaValues;

        } else {
            payload.blockCode = blockValues ? String(blockValues) : "0";
            payload.mulDistrictCode = "";
            payload.districtCode =
                Number(userLevelValue) > 2 &&
                    districtValue !== "NA" &&
                    districtValue !== "" &&
                    districtValue !== "Choose..."
                    ? String(districtValue)
                    : "";
        }



        // ---------------- Sub-District handling (NEW: scheme 8 MultiSelect) ----------------
        // if (schemeCode === "8" || schemeCode === "1") {
        if (BLOCKED_SCHEMES.includes(schemeGlobal)) {
            //console.log('Addd in scheme code 8 and 1 --');
            //console.log('working on');

            if (Array.isArray(selectedSubDistricts) && selectedSubDistricts.length > 0) {
                const subCodes = selectedSubDistricts
                    .map((item, index) => {

                        if (typeof item === 'object' && item?.value) {

                            return item.value;
                        }
                        return String(item);
                    })
                    .filter(code => code && code !== "" && code !== "undefined");

                const subNames = selectedSubDistricts
                    .map(o => (typeof o === 'object' ? o?.label : String(o)))
                    .filter(name => name && name !== "" && name !== "undefined");

                payload.mulSubDistrictCode = subCodes.join(","); // e.g. "401,402,405"
                payload.mulSubDistrictName = subNames.join(","); // e.g. "Tehsil A,Tehsil B"
                payload.subDistrictCode = ""; // keep single empty when multi is used

                // optional: persist
                sessionStorage.setItem("mulSubDistrictCode", payload.mulSubDistrictCode);
                sessionStorage.setItem("mulSubDistrictName", payload.mulSubDistrictName);
                //console.log('Addd in scheme code 8 aaaaaaaaaaaaaaaaaaaaaaa');
            } else {
                //console.log('Addd in scheme code 8 bbbbbbbbbbbbbbbbbbbbbbb');
                // console.log('subDistrictCodeModel: ', sessionStorage.getItem("subDistrictCodeModel"));

                // console.log('subDistrictValue add user', subDistrictValue);


                payload.mulSubDistrictCode = "";
                payload.mulSubDistrictName = "";
                //payload.subDistrictCode = sessionStorage.getItem("subDistrictCodeModel") ? "" : subDistrictValue;
                const sd = sessionStorage.getItem("subDistrictCodeModel");
                payload.subDistrictCode =
                    sd === null ||
                        sd === "null" ||
                        sd === "" ||
                        sd === "undefined"
                        ? String(subDistrictValue)
                        : sd;

                //payload.subDistrictCode = (sessionStorage.getItem("subDistrictCodeModel") ?? "").trim() !== ""
                //    ? sessionStorage.getItem("subDistrictCodeModel")
                //    : String(subDistrictValue);
            }
        } else {
            // Single sub-district select (non-8 schemes)
            payload.subDistrictCode =
                subDistrictValue &&
                    subDistrictValue !== "NA" &&
                    subDistrictValue !== "Choose..."
                    ? String(subDistrictValue)
                    : "";
            payload.mulSubDistrictCode = "";
            payload.mulSubDistrictName = "";
        }

        if (userLevelValue === "4" && sessionStorage.getItem("schemeCodeModel") === "5") {
            payload.gender = "u";
        } else if (userLevelValue === "6" && sessionStorage.getItem("schemeCodeModel") === "5") {
            payload.gender = "u";
        } else {
            payload.gender = gender;
        }

        // Conditionally add vcpid for schemeCode === "5"
        if (schemeCode === "5") {
            payload.vcpid = vCPValues === '' ? null : vCPValues;
        }
        if (schemeCode === "5" && sessionStorage.getItem("userTypeCodeModel") === "4") {
            payload.vcpid = sessionStorage.getItem("userCodeModel");
        }

        console.log("Final payload:", payload);

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify(payload);

        const apiPath =
            schemeCode === "5"
                ? "/api/NMEOSUsers/NEMOSUsers"
                : "/api/Management/CommUsers/addUser";

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }${apiPath}`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
                const parsedResult = JSON.parse(result);
                alert(parsedResult.message);
                if (parsedResult.success === true) {
                    navigate("/newadminpanel/userlist");
                }
            })
            .catch((error) => console.log("error", error));
    }


    function UpdateUser() {
        // console.log('state update: ', state);
        let localVillageValue = "";
        // console.log("selected: ", selected);

        const selectedVillageCodes = Array.isArray(selected) ? selected : [];

        //console.log("selected1111: ", selected);
        //console.log('selectedVillageCodes: ', selectedVillageCodes);

        const selectedCsv = Array.isArray(selected) && selected.length > 0 ? selected.join(",") : "";

        //console.log('selectedCsv: ', selectedCsv);
        // map codes -> option objects from `multiSubDistrictVillages`
        const codeToOption = new Map(multiSubDistrictVillages.map(o => [o.value, o]));

        //console.log('codeToOption: ', codeToOption);

        // recover full option objects (label/value/optional subdistrictName)
        const selectedVillageOptions = selectedVillageCodes
            .map(code => codeToOption.get(code))
            .filter(Boolean);

        // derive names (labels) if needed
        // const selectedVillageNames = selectedVillageOptions.map(opt => opt.label);
        //console.log('selectedVillageOptions: ', selectedVillageOptions);

        const selectedVillageCodes1 = selectedVillageOptions.map(opt => opt.value);

        // console.log("selectedVillageNames : ", selectedVillageNames);
        //console.log("selectedVillageCodes1 : ", selectedVillageCodes1);

        // if you also need sub-district names (when you attached `subdistrictName`)
        //const selectedSubdistrictNames = selectedVillageOptions
        //    .map(opt => opt.subdistrictName)
        //    .filter(Boolean);

        // setSelected(selectedVillageCodes1);

        selectedVillageCodes1.forEach((item) => {
            localVillageValue += item + ",";
        });

        //selected.forEach((item) => {
        //    localVillageValue += item + ",";
        //});

        localVillageValue = localVillageValue.slice(0, -1); // Remove trailing comma

        // console.log('localVillageValue: ', localVillageValue);

        const schemeCode = sessionStorage.getItem("schemeCodeModel");

        const baseUrl = process.env.NODE_ENV === 'development'
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE;

        const apiEndpoint = schemeCode === "5"
            ? "/api/NMEOSUsers"
            : "/api/Management/CommUsers/updateUser";

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        let payload = {
            modifiedByUC: sessionStorage.getItem("userCodeModel"),
            userRoleCode: userRoleValue,
            userCode: userCodeLocal,
            userName: userNameValue,
            userId: mobileValue,
            mobile: mobileValue,
            emailId: emailValue,
            gender: gender,
            departmentCode: "2",
            designationCode: String(designationValue),
            stateCode: String(stateValue),
            districtCode:
                Number(userLevelValue) > 2 &&
                    districtValue !== "NA" &&
                    districtValue !== "" &&
                    districtValue !== "Choose..."
                    ? String(districtValue)
                    : "",
            subDistrictCode:
                Number(userLevelValue) > 3 &&
                    subDistrictValue !== "NA" &&
                    subDistrictValue !== "" &&
                    subDistrictValue !== "Choose..."
                    ? String(subDistrictValue)
                    : "",
            blockCode: "0",
            //villageCode: Number(userLevelValue) > 4 ? String(localVillageValue) : "",
            userTypeCode: String(userLevelValue),
            schemeCode: schemeCode,
            isVisible: "Y",
            isActive: "Y",
            otp: "897678",
            isMobileVerified: "N",
            isEmailVerified: "N",
            orgTypeCode: "1"

        };

        // if (schemeCode === "8" || schemeCode === "1") {
        if (BLOCKED_SCHEMES.includes(schemeGlobal)) {
            const ids = Array.isArray(selectedDistrictIds)
                ? selectedDistrictIds.map(String).filter(Boolean)
                : [];

            payload.villageCode = Number(userLevelValue) > 4 ? String(localVillageValue) : "";
            if (ids.length > 0) {
                payload.mulDistrictCode = JSON.stringify(ids);
                payload.districtCode = "";
            } else {
                payload.mulDistrictCode = "";
                payload.districtCode = String(districtValue) || "";
            }

        } else {
            payload.villageCode = Number(userLevelValue) > 4 ? String(selectedCsv) : "";
            payload.mulDistrictCode = "";
            payload.districtCode =
                Number(userLevelValue) > 2 &&
                    districtValue !== "NA" &&
                    districtValue !== "" &&
                    districtValue !== "Choose..."
                    ? String(districtValue)
                    : "";
        }




        //// ---------------- Sub-District handling (NEW: scheme 8 MultiSelect) ----------------
        //  if (schemeCode === "8" || schemeCode === "1") {
        if (BLOCKED_SCHEMES.includes(schemeGlobal)) {
            //console.log('schemeCode 11111');
            //selectedSubDistricts
            console.log('selectedSubDistricts: ', selectedSubDistricts);
            if (Array.isArray(selectedSubDistricts) && selectedSubDistricts.length > 0) {
                console.log('selectedSubDistricts inside: ', selectedSubDistricts);
                const subCodes = selectedSubDistricts
                    .map((item, index) => {
                        if (typeof item === 'object' && item?.value) {
                            return String(item.value);
                        }
                        return String(item);
                    })
                    .filter(code => code && code !== "" && code !== "undefined");

                const subNames = selectedSubDistricts
                    .map(o => (typeof o === 'object' ? o?.label : String(o)))
                    .filter(name => name && name !== "" && name !== "undefined");
                console.log('subCodes: ', subCodes);

                // Send as JSON array instead of CSV string
                payload.mulSubDistrictCode = JSON.stringify(subCodes);  // ["1","2","3"]
                payload.mulSubDistrictName = JSON.stringify(subNames);  // ["Name1","Name2","Name3"]
                payload.subDistrictCode = ""; // keep single empty when multi is used

                // optional: persist
                sessionStorage.setItem("mulSubDistrictCode", subCodes);
                sessionStorage.setItem("mulSubDistrictName", subNames);
                // console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbb');
            } else if (Array.isArray(selectedBlock) && selectedBlock.length > 0) {
                const subCodes = selectedBlock
                    .map((item, index) => {
                        if (typeof item === 'object' && item?.value) {
                            return String(item.value);
                        }
                        return String(item);
                    })
                    .filter(code => code && code !== "" && code !== "undefined");

                const subNames = selectedBlock
                    .map(o => (typeof o === 'object' ? o?.label : String(o)))
                    .filter(name => name && name !== "" && name !== "undefined");

                // Send as JSON array instead of CSV string
                payload.mulBlockCode = JSON.stringify(subCodes);  // ["1","2","3"]
                payload.mulBlockName = JSON.stringify(subNames);  // ["Name1","Name2","Name3"]
                payload.blockCode = ""; // keep single empty when multi is used
            } else {
                console.log('Urban case');
                //console.log('aaaaaaaaaaaaaaaaaaaaa');
                //console.log('subDistrictValue value type:', typeof subDistrictValue)
                payload.mulSubDistrictCode = "";
                payload.mulSubDistrictName = "";
                //payload.subDistrictCode = sessionStorage.getItem("subDistrictCodeModel");
                payload.subDistrictCode = (sessionStorage.getItem("subDistrictCodeModel") ?? "").trim() !== ""
                    ? sessionStorage.getItem("subDistrictCodeModel")
                    : String(subDistrictValue);
            }
        } else {
            // Single sub-district select (non-8 schemes)
            payload.subDistrictCode =
                subDistrictValue &&
                    subDistrictValue !== "NA" &&
                    subDistrictValue !== "Choose..."
                    ? String(subDistrictValue)
                    : "";
            payload.mulSubDistrictCode = "";
            payload.mulSubDistrictName = "";
        }

        const rawUpdate = JSON.stringify(payload);

        console.log("raw update user Manvendra", payload);
        console.log('rawUpdate: ', rawUpdate);

        const requestOptions = {
            method: "PUT",
            headers: myHeaders,
            body: rawUpdate,
            redirect: "follow"
        };
        // console.log('apiEndpoint for Update');
        fetch(`${baseUrl}${apiEndpoint}`, requestOptions)
            .then((response) => response.text())
            .then((result) => {
                const parsed = JSON.parse(result);

                alert(parsed.message);
                if (parsed.success === true) {
                    navigate("/newadminpanel/userlist/");
                }
            })
            .catch((error) => console.log("error", error));
    }


    function handleMobileNumber(value) {
        const valueFinal = value.replace(/\D/g, "").replace(/^0/, "").replace(/^1/, "").replace(/^2/, "").replace(/^3/, "").replace(/^4/, "").replace(/^5/, "");
        setMobileValue(valueFinal)
    }

    function validateMobile() {

        if (mobileValue.length === 10) {
            document.getElementById("mobilenumber").style.borderColor = "green";
        } else {
            document.getElementById("mobilenumber").style.borderColor = "red";
        }
    }

    function handleUserLevel(value) {
        console.log('handleUserLevel called');
        console.log("setUserLevelValue@@", value);
        setUserRoleValue("");
        setUserLevelValue(value === "" || value == null ? "" : String(value));
        setAgencyValue("");
        setAgencyData([]);
        const roleTypeCode = value === "6" ? "6" : value === "7" ? "7" : value;
        fetchUserRole(roleTypeCode);
        
        if (value === "6") {
            fetchAgencyData(1);
        } else if (value === "7") {
            fetchAgencyData(2);
        }
        setBlockValues([]);
        setSelectedSubDistricts([]);
        setSelectedOption("");
        //setSubDistrictData([])
        setIsSubDistrictMultiSelect(false);
        //console.log('sessionStorage.getItem("schemeCodeModel") === "2" :', sessionStorage.getItem("schemeCodeModel") === "2");
        if (sessionStorage.getItem("schemeCodeModel") === "2" && !sessionStorage.getItem("subDistrictCodeModel")?.trim()) {
            const userType = Number(sessionStorage.getItem("userTypeCodeModel") || 0);
            if (userType > 3) {
                //console.log('1111111');
                setIsSubDistrictMultiSelect(true);
               // console.log('radios when creating new user if handleUserLevel');
                setSelectedOption("option1");
                setIsDisabledRadio(true);
            } else {
                //console.log('2222222');
                // setIsSubDistrictMultiSelect(true);
                setIsDisabledRadio(false);
            }
        } else {
            //console.log('333333');
            // setIsSubDistrictMultiSelect(true);
            //console.log('radios when creating new user else handleUserLevel');
            setSelectedOption("option2");
            setIsDisabledRadio(true);
        }

    }

    function validateEmail() {
        if (emailValue.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            document.getElementById("emailid").style.borderColor = "green";
        } else {
            document.getElementById("emailid").style.borderColor = "red";
        }
    }


    const handleChange = (selected) => {

        setSelected(selected.map(option => option.value));
    };


    const handleChangeDist = (selectedOptions) => {
        setSelectedDistrictIds(selectedOptions.map(o => String(o.value))); // ONE argument

    };


    function UpdateUser123() {
        let localVillageValue = "";
        selected.map((item) => {
            localVillageValue = localVillageValue + item.value + ","
        })

        localVillageValue = localVillageValue.slice(0, -1);

        //console.log("localVillageValue", localVillageValue)
    }

    function handleUserName(e) {
        let localText = e.target.value.replace(/[^\w\s]/gi, "")
        setUserNameValue(localText)
    }

    return (

        <>
            <AdminHeaderNew />
            <AdminSideBarNew />
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>User Creation</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Admin</li>
                            <li className="breadcrumb-item active">User Creation</li>
                        </ol>
                    </nav>
                    {/* <button type="button" className="btn btn-success" onClick={() => navigate("/newadminpanel/userlist")}>Back</button> */}
                </div>
                <section className="section dashboard newAdminForms">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className="col-md-4">
    <label className="form-label">
        User Level <span style={{ color: "red" }}>*</span>
    </label>

    <select
        className="form-select"
        onChange={(e) => handleUserLevel(e.target.value)}
        value={userLevelValue}
        id="userType"
        disabled={!!state}
    >
        <option value="">Choose...</option>
    </select>
</div>

{(String(userLevelValue) === "6" || String(userLevelValue) === "7") && (
    <div className="col-md-4">

        <label className="form-label">
            {String(userLevelValue) === "6"
                ? "Central Agency"
                : "State Agency"}
            <span style={{ color: "red" }}>*</span>
        </label>

        <select
            className="form-select"
            id="agency"
            value={agencyValue}
            onChange={(e) => setAgencyValue(e.target.value)}
        >
            <option value="">Choose...</option>

            {agencyData?.map((item, idx) => (
                <option
                    key={idx}
                    value={
                        item.agencyId ??
                        item.id ??
                        item.agencyCode ??
                        idx
                    }
                >
                    {
                        item.agencyName ??
                        item.name ??
                        item.agencyTypeName
                    }
                </option>
            ))}
        </select>

    </div>
)}

                                        <div className="col-md-4" id="stateDiv" style={{ display: userLevelValue === "7" ? "none" : "" }}>
                                            <label htmlFor="State" className="form-label" id="StateLabel">
                                                State
                                            </label><label style={{ color: "red" }}>*</label>
                                            <select
                                                id="State"
                                                required
                                                className="form-select"
                                                onClick={getStates}
                                                onChange={(e) => handleState(e.target.value)}
                                                value={stateValue}
                                                name="stateCode"
                                                disabled={state ? true : false}
                                            >
                                                <option value="NA">Choose...</option>
                                                {statesData ? statesData.map((item, id) => {
                                                    return (
                                                        <option key={id} value={item.stateCode}>
                                                            {" "}
                                                            {item.stateName} ({item.stateCode})
                                                        </option>
                                                    );
                                                }) : ""}
                                            </select>
                                        </div>

                                        {/*{console.log('selectedDistrictOptions: ', selectedDistrictOptions)}*/}
                                        {/*{console.log('optionsSubDistrictNew: ', optionsSubDistrictNew)}*/}

                                        {userLevelValue !== "7" && (userLevelValue > 2 || Number(sessionStorage.getItem("userTypeCodeModel")) > 2) ? (
                                            /*sessionStorage.getItem("schemeCodeModel") === "8" && userLevelValue === "3" ? (*/
                                            /* sessionStorage.getItem("schemeCodeModel") === "8" && state != null && userLevelValue !== "4" && clickUpdate ? (*/
                                            //(sessionStorage.getItem("schemeCodeModel") === "8" ||
                                            //    sessionStorage.getItem("schemeCodeModel") === "1") ? (state != null ? (

                                            (isSchemeBlocked) ? (state != null ? (

                                                (userLevelValue === "3") ? (
                                                    <>
                                                        <div className="col-md-4" id="districtDiv">
                                                            <label htmlFor="District" className="form-label" id="DistrictLabel">
                                                                District
                                                            </label>
                                                            <label style={{ color: "red" }}>*</label>


                                                            <MultiSelect
                                                                options={optionsSubDistrictNew}
                                                                value={selectedDistrictOptions.map(item => ({
                                                                    label: item.label,
                                                                    value: String(item.value)   // convert number → string
                                                                }))}         //  optionsDistrict USE DERIVED OPTIONS, not selectedDist
                                                                onChange={handleChangeDist}
                                                                labelledBy="Select"
                                                                isCreatable
                                                            />
                                                        </div>
                                                    </>
                                                ) : (

                                                    (userLevelValue !== 4) ? (

                                                        (userLevelValue !== 5) ? (

                                                            <div className="col-md-4" id="districtDiv">
                                                                <label htmlFor="District" className="form-label" id="DistrictLabel">
                                                                    District
                                                                </label>
                                                                <label style={{ color: "red" }}>*</label>
                                                                <MultiSelect
                                                                    options={optionsDistrict}
                                                                    value={selectedDistrictOptions}         // USE DERIVED OPTIONS, not selectedDist
                                                                    onChange={handleChangeDist}
                                                                    labelledBy="Select"
                                                                    isCreatable
                                                                />
                                                            </div>
                                                        ) : (
                                                            <div className="col-md-4" id="districtDiv">
                                                                <label htmlFor="District" className="form-label" id="DistrictLabel">
                                                                    District
                                                                </label>
                                                                <label style={{ color: "red" }}>*</label>
                                                                <select
                                                                    id="District"
                                                                    className="form-select"
                                                                    onChange={(e) => handleDistrict(e.target.value)}
                                                                    value={districtValue}
                                                                    disabled={true}
                                                                >
                                                                    <option defaultValue value="NA">Choose...</option>
                                                                    {districtData ? districtData.map((item, id) => (
                                                                        <option key={id} value={item.districtCode}>
                                                                            {item.districtName} ({item.districtCode})
                                                                        </option>
                                                                    )) : ""}
                                                                </select>
                                                            </div>
                                                        )


                                                    ) : (
                                                        <div className="col-md-4" id="districtDiv">
                                                            <label htmlFor="District" className="form-label" id="DistrictLabel">
                                                                District
                                                            </label>
                                                            <label style={{ color: "red" }}>*</label>
                                                            <select
                                                                id="District"
                                                                className="form-select"
                                                                onChange={(e) => handleDistrict(e.target.value)}
                                                                value={districtValue}
                                                                disabled={true}
                                                            >
                                                                <option defaultValue value="NA">Choose...</option>
                                                                {districtData ? districtData.map((item, id) => (
                                                                    <option key={id} value={item.districtCode}>
                                                                        {item.districtName} ({item.districtCode})
                                                                    </option>
                                                                )) : ""}
                                                            </select>
                                                        </div>
                                                    )

                                                )


                                            ) : (

                                                (userLevelValue !== "3") ? (
                                                    <div className="col-md-4" id="districtDiv">
                                                        <label htmlFor="District" className="form-label" id="DistrictLabel">
                                                            District
                                                        </label>
                                                        <label style={{ color: "red" }}>*</label>
                                                        <select
                                                            id="District"
                                                            className="form-select"
                                                            onChange={(e) => handleDistrict(e.target.value)}
                                                            value={districtValue}
                                                            disabled={true}
                                                        >
                                                            <option defaultValue value="NA">Choose...</option>
                                                            {districtData ? districtData.map((item, id) => (
                                                                <option key={id} value={item.districtCode}>
                                                                    {item.districtName} ({item.districtCode})
                                                                </option>
                                                            )) : ""}
                                                        </select>
                                                    </div>
                                                ) : (<div className="col-md-4" id="districtDiv">
                                                    <label htmlFor="District" className="form-label" id="DistrictLabel">
                                                        District
                                                    </label>
                                                    <label style={{ color: "red" }}>*</label>
                                                    <MultiSelect
                                                        options={optionsDistrict}
                                                        value={selectedDistrictOptions}         // USE DERIVED OPTIONS, not selectedDist
                                                        onChange={handleChangeDist}
                                                        labelledBy="Select"
                                                        isCreatable
                                                    />
                                                </div>
                                                )



                                            )
                                            ) : (<>

                                                {
                                                    /*WorkHere*/
                                                    sessionStorage.getItem("schemeCodeModel") !== "1" && (
                                                        <div className="col-md-4" id="districtDiv">
                                                            <label htmlFor="District" className="form-label" id="DistrictLabel">
                                                                District
                                                            </label>
                                                            <label style={{ color: "red" }}>*</label>

                                                            <select
                                                                id="District"
                                                                className="form-select"
                                                                onChange={(e) => handleDistrict(e.target.value)}
                                                                value={districtValue}
                                                            >
                                                                <option defaultValue value="NA">Choose...</option>

                                                                {districtData
                                                                    ? districtData.map((item, id) => (
                                                                        <option key={id} value={item.districtCode}>
                                                                            {item.districtName} ({item.districtCode})
                                                                        </option>
                                                                    ))
                                                                    : ""}
                                                            </select>
                                                        </div>
                                                    )
                                                }
                                            </>

                                            )
                                        ) : ""}



                                        {userLevelValue === "5" && sessionStorage.getItem("schemeCodeModel") === "5" && sessionStorage.getItem("userTypeCodeModel") !== "4" &&
                                            <div className="col-md-4" id="subDistrictDiv">
                                                <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                                                    VCP
                                                </label>
                                                <label style={{ color: "red" }}>*</label>
                                                <select
                                                    id="subDistrict"
                                                    className="form-select"
                                                    onChange={(e) => setVCPValues(e.target.value)}
                                                    value={vCPValues}
                                                >
                                                    <option defaultValue value="NA">Choose...</option>

                                                    {vcpData.map((item, id) => (
                                                        <option key={id} value={item.userCode}>
                                                            {item.userName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        }

                                        {districtValue !== "" &&
                                            userLevelValue > 3 &&
                                            sessionStorage.getItem("schemeCodeModel") === "2" && (
                                                <div className="col-md-4">
                                                    <label className="form-label">Select Option</label>
                                                    <label style={{ color: "red" }}>*</label>

                                                    <div className="d-flex">
                                                        <div className="form-check me-3">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="option"
                                                                id="option1"
                                                                value="option1"
                                                                checked={selectedOption === "option1"}   // controlled
                                                                onChange={handleRadioChange}
                                                                disabled={isDisabledRadio}
                                                            />
                                                            <label className="form-check-label" htmlFor="option1">
                                                                Rural
                                                            </label>
                                                        </div>

                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="option"
                                                                id="option2"
                                                                value="option2"
                                                                checked={selectedOption === "option2"}   // controlled
                                                                onChange={handleRadioChange}
                                                                disabled={isDisabledRadio}
                                                            />
                                                            <label className="form-check-label" htmlFor="option2">
                                                                Urban
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }

                                        {/*{districtValue !== "" && userLevelValue > 3 && sessionStorage.getItem("schemeCodeModel") === "2" && (*/}
                                        {/*    <div className="col-md-4">*/}
                                        {/*        <label className="form-label">Select Option</label>*/}
                                        {/*        <label style={{ color: "red" }}>*</label>*/}
                                        {/*        <div className="d-flex">*/}
                                        {/*            <div className="form-check me-3">*/}
                                        {/*                <input*/}
                                        {/*                    className="form-check-input"*/}
                                        {/*                    type="radio"*/}
                                        {/*                    name="option"*/}
                                        {/*                    id="option1"*/}
                                        {/*                    value="option1"*/}
                                        {/*                    onChange={handleRadioChange}*/}
                                        {/*                />*/}
                                        {/*                <label className="form-check-label" htmlFor="option1">*/}
                                        {/*                    Rural*/}
                                        {/*                </label>*/}
                                        {/*            </div>*/}
                                        {/*            <div className="form-check">*/}
                                        {/*                <input*/}
                                        {/*                    className="form-check-input"*/}
                                        {/*                    type="radio"*/}
                                        {/*                    name="option"*/}
                                        {/*                    id="option2"*/}
                                        {/*                    value="option2"*/}
                                        {/*                    onChange={handleRadioChange}*/}
                                        {/*                />*/}
                                        {/*                <label className="form-check-label" htmlFor="option2">*/}
                                        {/*                    Urban*/}
                                        {/*                </label>*/}
                                        {/*            </div>*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*)}*/}

                                        {/* {console.log("optionsSubDistrictNew at sub-districtLevel ", optionsSubDistrictNew)}
                                        {console.log("subDistrictData at sub-districtLevel ", subDistrictData)}
                                        {console.log("userLevelValue: ", userLevelValue)}
                                        {console.log('userLevelValue value type:', typeof userLevelValue)}
                                        {console.log('selectedOption: ', selectedOption)}
                                        {console.log('isSchemeBlocked: ', isSchemeBlocked)}
                                        {console.log('sessionStorage.getItem("userTypeCodeModel") value type:', typeof sessionStorage.getItem("userTypeCodeModel"))}
                                        {console.log('sessionStorage.getItem("userTypeCodeModel") > 3: ', sessionStorage.getItem("userTypeCodeModel") > 3) } */}
                                       
                                        {userLevelValue !== "7" && (Number(userLevelValue) > 3 || sessionStorage.getItem("userTypeCodeModel") > 3) &&
                                            sessionStorage.getItem("schemeCodeModel") === "2" && selectedOption === "option2" && (
                                            /*isSchemeBlocked ? (String(userLevelValue) === "5" ? (<>*/
                                            isSchemeBlocked ? (String(userLevelValue) === "5" ? (<>
                                                {Array.isArray(subDistrictData) && (

                                                    sessionStorage.getItem("userTypeCodeModel") === "4" ? (
                                                        <div className="col-md-4" id="subDistrictDiv">
                                                            <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                                                                Sub-District
                                                            </label>
                                                            <label style={{ color: "red" }}>*</label>
                                                        <MultiSelect
                                                            options={optionsSubDistrictNew}             // [{ label, value }]
                                                            value={selectedSubDistricts}                // array of selected {label, value}
                                                            onChange={handleSubDistrictMultiChange}     // callback function
                                                            labelledBy="Select Sub-District(s)"
                                                            isCreatable
                                                            />
                                                        </div>

                                                    ) : (

                                                        <div className="col-md-4" id="subDistrictDiv">
                                                            <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                                                                Sub-District
                                                            </label>
                                                            <label style={{ color: "red" }}>*</label>

                                                            {/* Convert subDistrictData → options for MultiSelect */}
                                                            {
                                                                (() => {

                                                                const optionsSubDistrictNew = subDistrictData.map((item) => ({
                                                                 label: `${item.subDistrictName} (${item.subDistrictCode})`,
                                                                value: `${item.subDistrictCode}`,
                                                                }));
                                                                console.log('optionsSubDistrictArun: ', optionsSubDistrictNew);
                                                                return (
                                                                    <MultiSelect
                                                                        options={optionsSubDistrictNew}             // [{ label, value }]
                                                                        value={selectedSubDistricts}                // array of selected {label, value}
                                                                        onChange={handleSubDistrictMultiChange}     // callback function
                                                                        labelledBy="Select Sub-District(s)"
                                                                        isCreatable
                                                                    />
                                                                );
                                                        })()

                                                        }
                                                    </div>
                                                    )


                                                    )}
                                                </>) : (
                                                    <>
                                                        
                                                        {Array.isArray(subDistrictData) && (
                                                            <div className="col-md-4" id="subDistrictDiv">
                                                                <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                                                                    Sub-District
                                                                </label>
                                                                <label style={{ color: "red" }}>*</label>

                                                                {/* Convert subDistrictData → options for MultiSelect */}

                                                                {(
                                                                        (() => {
                                                                        const optionsSubDistrictNew =
                                                                                    subDistrictData.map((item) => ({
                                                                                        label: `${item.subDistrictName} (${item.subDistrictCode})`,
                                                                                        value: `${item.subDistrictCode}`,
                                                                                    }));
                                                                                console.log('isSubDistrictMultiSelect: ', isSubDistrictMultiSelect);
                                                                                return (
                                                                                    <>
                                                                                       
                                                                                        <MultiSelect
                                                                                            options={optionsSubDistrictNew}             // [{ label, value }]
                                                                                            value={selectedSubDistricts}                // array of selected {label, value}
                                                                                            onChange={handleSubDistrictMultiChange}     // callback function
                                                                                            labelledBy="Select Sub-District(s)"
                                                                                            isCreatable
                                                                                            disabled={isSubDistrictMultiSelect}
                                                                                        />
                                                                                    </>
                                                                                );
                                                                            })()
                                                                    )

                                                                }
                                                            </div>
                                                        )}
                                                    </>
                                                )
                                                ) : (
                                                    <div className="col-md-4" id="subDistrictDiv">
                                                        <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                                                            Sub-District

                                                        </label>
                                                        <label style={{ color: "red" }}>*</label>
                                                        <select
                                                            id="subDistrict"
                                                            className="form-select"
                                                            onChange={(e) => handleVillage(e.target.value)}
                                                            value={subDistrictValue}
                                                        >
                                                            <option defaultValue value="NA">Choose...</option>

                                                            {subDistrictData.map((item, id) => (
                                                                <option key={id} value={item.subDistrictCode}>
                                                                    {item.subDistrictName} ({item.subDistrictCode})
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                )
                                            )}
                                        {/*{console.log('selectedBlock optionsSubDistrictNew: ', optionsSubDistrictNew)}*/}
                                        {/*{console.log('selectedBlock userLevelValue: ', userLevelValue)}*/}
                                        {/*{console.log('blockValue: ', blockValue)}*/}
                                        {/*{console.log('userLevelValue value type:', typeof userLevelValue)}*/}
                                        {userLevelValue !== "7" && (userLevelValue > 3 || sessionStorage.getItem("userTypeCodeModel") > 3) &&
                                            sessionStorage.getItem("schemeCodeModel") === "2" && sessionStorage.getItem("schemeCodeModel") !== "5" &&
                                            selectedOption === "option1" && (
                                                isSchemeBlocked ? (String(userLevelValue) === "5" ? (
                                                    <>
                                                        {
                                                            sessionStorage.getItem("userTypeCodeModel") === "3" ? (
                                                                <div className="col-md-4" id="subDistrictDiv">
                                                                    <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                                                                        Block
                                                                    </label>
                                                                    <label style={{ color: "red" }}>*</label>

                                                                    <MultiSelect
                                                                        options={blockValue.map(item => ({
                                                                            label: `${item.blockName} (${item.blockCode})`,
                                                                            value: item.blockCode
                                                                        }))}

                                                                        // Always keep value as array
                                                                        value={Array.isArray(selectedBlock) ? selectedBlock : []}

                                                                        onChange={(selected) => {
                                                                            setBlockValues(selected);
                                                                            setSelectedBlock(selected);
                                                                            handleBlockMulSelect(selected); // send complete selected array
                                                                        }}

                                                                        labelledBy="Select Blocks"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    {console.log('optionsSubDistrictNew: ', optionsSubDistrictNew)}
                                                                    {console.log('selectedBlock: ', selectedBlock)}
                                                                    <div className="col-md-4" id="subDistrictDiv">
                                                                        <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                                                                            Block
                                                                        </label>
                                                                        <label style={{ color: "red" }}>*</label>

                                                                        <MultiSelect
                                                                            options={optionsSubDistrictNew.map(item => ({
                                                                                label: item.label,
                                                                                value: Number(item.value)
                                                                            }))}

                                                                            // Always keep value as array
                                                                            value={Array.isArray(selectedBlock) ? selectedBlock : []}

                                                                            onChange={(selected) => {
                                                                                setBlockValues(selected);
                                                                                setSelectedBlock(selected);
                                                                                handleBlockMulSelect(selected); // send complete selected array
                                                                            }}

                                                                            labelledBy="Select Blocks"
                                                                        />
                                                                    </div>
                                                                </>
                                                            )
                                                        }

                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="col-md-4" id="subDistrictDiv">
                                                            <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                                                                Block
                                                            </label>
                                                            <label style={{ color: "red" }}>*</label>

                                                            <MultiSelect
                                                                options={blockValue.map(item => ({
                                                                    label: `${item.blockName} (${item.blockCode})`,
                                                                    value: item.blockCode
                                                                }))}

                                                                //  Ensure value is ALWAYS an array
                                                                value={Array.isArray(selectedBlock) ? selectedBlock : []}

                                                                onChange={(selected) => {
                                                                    //  store selected objects for MultiSelect
                                                                    setBlockValues(selected);
                                                                    setSelectedBlock(selected);
                                                                    //  pass only codes to your handler
                                                                    //handleBlockMulSelect(selected.map(item => item.value));
                                                                    handleBlockMulSelect(selected);
                                                                }}

                                                                labelledBy="Select Blocks"
                                                            />
                                                            {/* <div>{console.log(multiSubDistrictVillages}</div>*/}
                                                        </div> </>
                                                )

                                                ) : (
                                                    <div className="col-md-4" id="subDistrictDiv">
                                                        <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                                                            Block
                                                        </label>
                                                        <label style={{ color: "red" }}>*</label>
                                                        <select
                                                            id="subDistrict"
                                                            className="form-select"
                                                            onChange={(e) => handleBlock(e.target.value)}
                                                            value={blockValues}
                                                        >
                                                            <option defaultValue value="NA">Choose...</option>

                                                            {blockValue.map((item, id) => (
                                                                <option key={id} value={item.blockCode}>
                                                                    {item.blockName} ({item.blockCode})
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )
                                            )}
                                        {userLevelValue !== "7" && (userLevelValue > 3 || Number(sessionStorage.getItem("userTypeCodeModel")) > 3) &&
                                            sessionStorage.getItem("schemeCodeModel") !== "2" &&
                                            sessionStorage.getItem("schemeCodeModel") !== "5" && (
                                                /* (sessionStorage.getItem("schemeCodeModel") === "8" || sessionStorage.getItem("schemeCodeModel") === "1") ? (*/
                                                (isSchemeBlocked) ? (
                                                    /*   (sessionStorage.getItem("schemeCodeModel") === "8") ? (*/
                                                    (sessionStorage.getItem("userTypeCodeModel") !== "4") ? (

                                                        (userLevelValue === "5" && sessionStorage.getItem("userTypeCodeModel") === "3") ?
                                                            (

                                                                <>


                                                                    {Array.isArray(subDistrictData) && (
                                                                        <div className="col-md-4" id="subDistrictDiv">
                                                                            <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                                                                                Sub-District
                                                                            </label>
                                                                            <label style={{ color: "red" }}>*</label>

                                                                            {/* Convert subDistrictData → options for MultiSelect */}
                                                                            {(() => {
                                                                                const optionsSubDistrictNew = subDistrictData.map((item) => ({
                                                                                    label: `${item.subDistrictName} (${item.subDistrictCode})`,
                                                                                    value: item.subDistrictCode,
                                                                                }));

                                                                                return (
                                                                                    <MultiSelect
                                                                                        options={optionsSubDistrictNew}             // [{ label, value }]
                                                                                        value={selectedSubDistricts}                // array of selected {label, value}
                                                                                        onChange={handleSubDistrictMultiChange}     // callback function
                                                                                        labelledBy="Select Sub-District(s)"
                                                                                        isCreatable
                                                                                    />
                                                                                );
                                                                            })()}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                (userLevelValue === 5) ? (
                                                                    <>


                                                                        {Array.isArray(subDistrictData) && (
                                                                            <div className="col-md-4" id="subDistrictDiv">
                                                                                <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                                                                                    Sub-District
                                                                                </label>
                                                                                <label style={{ color: "red" }}>*</label>

                                                                                {/* Convert subDistrictData → options for MultiSelect */}
                                                                                {(() => {
                                                                                    const optionsSubDistrictNew = subDistrictData.map((item) => ({
                                                                                        label: `${item.subDistrictName} (${item.subDistrictCode})`,
                                                                                        value: `${item.subDistrictCode}`,
                                                                                    }));
                                                                                    // console.log('optionsSubDistrictNew : ', optionsSubDistrictNew);
                                                                                    return (
                                                                                        <MultiSelect
                                                                                            options={optionsSubDistrictNew}             // [{ label, value }]
                                                                                            value={selectedSubDistricts}                // array of selected {label, value}
                                                                                            onChange={handleSubDistrictMultiChange}     // callback function
                                                                                            labelledBy="Select Sub-District(s)"
                                                                                            isCreatable
                                                                                        />
                                                                                    );
                                                                                })()}
                                                                            </div>
                                                                        )}
                                                                    </>

                                                                ) : (
                                                                    <>

                                                                        <div className="col-md-4" id="subDistrictDiv">
                                                                            <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                                                                                Sub-District
                                                                            </label>
                                                                            <label style={{ color: "red" }}>*</label>

                                                                            <MultiSelect
                                                                                options={optionsSubDistrict}             // [{ label, value }]
                                                                                value={selectedSubDistricts}             // same shape
                                                                                onChange={handleSubDistrictMultiChange}  // not event-based
                                                                                labelledBy="Select"
                                                                                isCreatable
                                                                            />
                                                                        </div>
                                                                    </>

                                                                )
                                                            )

                                                    ) : (
                                                        <>
                                                            {//console.log('multiSubDistrictVillages: ', multiSubDistrictVillages) 
                                                            }
                                                            <div className="col-md-4" id="subDistrictDiv">
                                                                <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                                                                    Sub-District
                                                                </label>
                                                                <label style={{ color: "red" }}>*</label>
                                                                {/*<select*/}
                                                                {/*    id="subDistrict"*/}
                                                                {/*    className="form-select"*/}
                                                                {/*    onChange={(e) => handleVillage(e.target.value)}*/}
                                                                {/*        value={String(subDistrictValue)}*/}
                                                                {/*    disabled*/}
                                                                {/*>*/}
                                                                {/*    <option defaultValue value="NA">{subDistrictValue}</option>*/}
                                                                {/*    {subDistrictData.map((item, id) => (*/}
                                                                {/*        <option key={id} value={item.subDistrictCode}>*/}
                                                                {/*            {item.subDistrictName} ({item.subDistrictCode})*/}
                                                                {/*        </option>*/}
                                                                {/*    ))}*/}
                                                                {/*    </select>*/}

                                                                <MultiSelect
                                                                    options={optionsSubDistrictNew}             // [{ label, value }]
                                                                    value={selectedSubDistricts}             // same shape
                                                                    onChange={handleSubDistrictMultiChange}  // not event-based
                                                                    labelledBy="Select"
                                                                    isCreatable
                                                                />

                                                            </div>
                                                        </>
                                                    )


                                                ) : (
                                                    <>

                                                        {
                                                            sessionStorage.getItem("schemeCodeModel") !== "1" && (
                                                                <div className="col-md-4" id="subDistrictDiv">
                                                                    <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                                                                        Sub-District
                                                                    </label>
                                                                    <label style={{ color: "red" }}>*</label>
                                                                    <select
                                                                        id="subDistrict"
                                                                        className="form-select"
                                                                        onChange={(e) => handleVillage(e.target.value)}
                                                                        value={subDistrictValue}
                                                                    >
                                                                        <option defaultValue value="NA">Choose...</option>
                                                                        {subDistrictData.map((item, id) => (
                                                                            <option key={id} value={item.subDistrictCode}>
                                                                                {item.subDistrictName} ({item.subDistrictCode})
                                                                            </option>
                                                                        ))}
                                                                    </select>

                                                                </div>
                                                            )
                                                        }
                                                    </>
                                                )
                                            )}



                                        {userLevelValue !== "7" && sessionStorage.getItem("schemeCodeModel") !== "5" &&
                                            (userLevelValue > 4 || sessionStorage.getItem("userTypeCodeModel") > 4) && (

                                                <>

                                                    <div className="col-md-4" id="villageDiv">
                                                        <label htmlFor="village" className="form-label">
                                                            Village
                                                        </label>
                                                        <label style={{ color: "red" }}>*</label>

                                                        {!BLOCKED_SCHEMES.includes(sessionStorage.getItem("schemeCodeModel")) ? (
                                                            <>

                                                                <MultiSelect
                                                                    options={optionsState}
                                                                    value={optionsState.filter((option) => selected.includes(option.value))}
                                                                    onChange={handleChange}
                                                                    labelledBy="Select"
                                                                    isCreatable={true}
                                                                />
                                                            </>
                                                        ) : (
                                                            <>

                                                                <MultiSelect
                                                                    options={multiSubDistrictVillages}
                                                                    value={multiSubDistrictVillages.filter((option) =>
                                                                        selected.includes(option.value)
                                                                    )}
                                                                    onChange={handleChange}
                                                                    labelledBy="Select"
                                                                    isCreatable={true}
                                                                />
                                                            </>
                                                        )}
                                                    </div>
                                                </>
                                            )}

                                        <div className="col-md-4">
                                            <label htmlFor="userRole" className="form-label">
                                                Role
                                            </label><label style={{ color: "red" }}>*</label>
                                            <select
                                                id="userRole"
                                                required
                                                className="form-control"
                                                onChange={(e) => setUserRoleValue(e.target.value.toString())}
                                                value={userRoleValue}
                                                disabled // disables the select (readonly)
                                            >
                                                {Array.isArray(userRoleData) && userRoleData.length > 0 ? (
                                                    userRoleData.map((item, id) => (
                                                        <option key={id} value={item.userRoleCode}>
                                                            {item.userRoleName}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option disabled>No roles available</option>
                                                )}
                                            </select>
                                        </div>
                                        <div className='col-md-4'>
                                            <label className="form-label">User Name</label><label style={{ color: "red" }}>*</label>
                                            <input
                                                placeholder="User Name"
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^[a-zA-Z\s]*$/.test(value)) {
                                                        handleUserName(e);
                                                    }
                                                }}
                                                value={userNameValue}
                                                maxLength={50}

                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="mobileNo" className="form-label">
                                                Mobile No.
                                            </label><label style={{ color: "red" }}>*</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="mobilenumber"
                                                required
                                                placeholder="Mobile No."
                                                onChange={(e) => handleMobileNumber(e.target.value)}
                                                value={mobileValue}
                                                onKeyUp={validateMobile}
                                                maxLength="10"
                                                readOnly={state ? true : false}

                                            />

                                            {/* {mobileVerify ? <span style={{color: 'green'}}>Mobile Number Successfully Verified</span> : 
             <div className="d-md-flex justify-content-md-end mt-1"><span id="timer_text"></span><input type="button" className="btn btn-success btn-sm" id="send_otp_btn" value={OTPSend ? "Resend OTP" : "Send OTP"} onClick={validateMobileNumber} /></div>} */}


                                        </div>
                                        {/* {OTPSend ? 
                  <div className="col-md-4">
                    <label htmlFor="otp" className="form-label">
                      OTP Verification Code
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="otpnumber"
                      required
                      placeholder="Enter OTP"
                      onChange={(e) => setMobileOTP(e.target.value)}
                      // value={aadharNumber}
                      // onKeyUp={validateAadhar}
                    />
                  <div className="d-md-flex justify-content-md-end mt-2"> <input type="button" className="btn btn-success btn-sm" value="Verify" onClick={verifyMobileNumber}/></div>
                  </div> : '' } */}



                                        <div className="col-md-4">
                                            <label htmlFor="Designation" className="form-label">
                                                Designation
                                            </label><label style={{ color: "red" }}>*</label>
                                            <select
                                                id="Designation"
                                                required
                                                className="form-select"
                                                onChange={(e) => setDesignationValue(e.target.value)}
                                                value={designationValue}
                                            >
                                                <option defaultValue>Choose...</option>
                                                {designationData
                                                    .filter((item) => {
                                                        const schemeCode = sessionStorage.getItem("schemeCodeModel");
                                                        if (schemeCode === "5") return true;
                                                        return item.desigCode !== 30 && item.desigCode !== 31;
                                                    })
                                                    .map((item, id) => (
                                                        <option key={id} value={item.desigCode}>
                                                            {item.desigName}
                                                        </option>
                                                    ))}
                                            </select>


                                        </div>

                                        <div className='col-md-4'>
                                            <label className="form-label">Email Id:</label><label style={{ color: "red" }}>*</label>
                                            <input placeholder='Email Id' type='text' id="emailid" className='form-control' onChange={(e) => setEmailValue(e.target.value)} value={emailValue} onKeyUp={validateEmail}
                                                maxLength={50} readOnly={state ? true : false} />
                                        </div>


                                        {sessionStorage.getItem("schemeCodeModel") != 5 &&
                                            <div className="col-md-4">
                                                <div className="col-md-12">
                                                    <label htmlFor="emailAddress" className="form-label">
                                                        Gender
                                                    </label>
                                                </div>

                                                <div className="col-md-12">
                                                    <div className="form-check form-check-inline" onClick={() => setGender("M")}>
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="gender"
                                                            id="inlineRadio1"
                                                            value="male"
                                                            checked={gender === "M"}
                                                        />
                                                        <label className="form-check-label" htmlFor="inlineRadio1">Male</label>
                                                    </div>
                                                    <div className="form-check form-check-inline" onClick={() => setGender("F")}>
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="gender"
                                                            id="inlineRadio2"
                                                            value="female"
                                                            checked={gender === "F"}
                                                        />
                                                        <label className="form-check-label" htmlFor="inlineRadio2">Female</label>
                                                    </div>
                                                    <div className="form-check form-check-inline" onClick={() => setGender("T")}>
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="gender"
                                                            id="inlineRadio3"
                                                            value="transgender"
                                                            checked={gender === "T"}
                                                        />
                                                        <label className="form-check-label" htmlFor="inlineRadio3">Other</label>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {sessionStorage.getItem("schemeCodeModel") === "5" &&
                                            userLevelValue != 4 && userLevelValue != 6 &&
                                            (
                                                <div className="col-md-4">
                                                    <div className="col-md-12">
                                                        <label htmlFor="emailAddress" className="form-label">
                                                            Gender
                                                        </label>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="form-check form-check-inline" onClick={() => setGender("M")}>
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="gender"
                                                                id="inlineRadio1"
                                                                value="male"
                                                                checked={gender === "M"}
                                                            />
                                                            <label className="form-check-label" htmlFor="inlineRadio1">Male</label>
                                                        </div>
                                                        <div className="form-check form-check-inline" onClick={() => setGender("F")}>
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="gender"
                                                                id="inlineRadio2"
                                                                value="female"
                                                                checked={gender === "F"}
                                                            />
                                                            <label className="form-check-label" htmlFor="inlineRadio2">Female</label>
                                                        </div>
                                                        <div className="form-check form-check-inline" onClick={() => setGender("T")}>
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="gender"
                                                                id="inlineRadio3"
                                                                value="transgender"
                                                                checked={gender === "T"}
                                                            />
                                                            <label className="form-check-label" htmlFor="inlineRadio3">Other</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                    </div>

                                    <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                                        {state ? (
                                            <button
                                                className="btn btn-success me-md-2 mt-5"
                                                type="button"
                                                onClick={ValidateAddUser}
                                            >
                                                Update User
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-success me-md-2 mt-5 "
                                                type="button"
                                                onClick={ValidateAddUser}
                                            >
                                                Create User
                                            </button>
                                        )}

                                        {/* {state ? "" : <button
                      className="btn btn-outline-primary"
                      type="button"
                      onClick={handleResetForm}
                    >
                      Reset
                    </button>  } */}
                                        <button
                                            className="btn btn-outline-danger mt-5"
                                            type="button"
                                            onClick={() => navigate("/newadminpanel/userlist")}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </section>
            </main>
            <AdminFooterNew />
        </>
    )

}

export default UserCreation;
